import { Record } from "../fable_modules/fable-library-js.4.17.0/Types.js";
import { option_type, bool_type, array_type, int32_type, record_type, string_type, float64_type } from "../fable_modules/fable-library-js.4.17.0/Reflection.js";

export class PriceEntry extends Record {
    constructor(Price, Currency, Time) {
        super();
        this.Price = Price;
        this.Currency = Currency;
        this.Time = Time;
    }
}

export function PriceEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.PriceEntry", [], PriceEntry, () => [["Price", float64_type], ["Currency", string_type], ["Time", string_type]]);
}

export class CommodityEntry extends Record {
    constructor(CommodityId, Ticker, Name, Latest, Compare) {
        super();
        this.CommodityId = (CommodityId | 0);
        this.Ticker = Ticker;
        this.Name = Name;
        this.Latest = Latest;
        this.Compare = Compare;
    }
}

export function CommodityEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.CommodityEntry", [], CommodityEntry, () => [["CommodityId", int32_type], ["Ticker", string_type], ["Name", string_type], ["Latest", PriceEntry_$reflection()], ["Compare", PriceEntry_$reflection()]]);
}

export class CurrencyEntry extends Record {
    constructor(CurrencyId, Ticker, Name, Latest, Compare) {
        super();
        this.CurrencyId = (CurrencyId | 0);
        this.Ticker = Ticker;
        this.Name = Name;
        this.Latest = Latest;
        this.Compare = Compare;
    }
}

export function CurrencyEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.CurrencyEntry", [], CurrencyEntry, () => [["CurrencyId", int32_type], ["Ticker", string_type], ["Name", string_type], ["Latest", PriceEntry_$reflection()], ["Compare", PriceEntry_$reflection()]]);
}

export class AssetChangeEntry extends Record {
    constructor(AssetId, Name, Ticker, Market, Percentage, Price) {
        super();
        this.AssetId = (AssetId | 0);
        this.Name = Name;
        this.Ticker = Ticker;
        this.Market = Market;
        this.Percentage = (Percentage | 0);
        this.Price = Price;
    }
}

export function AssetChangeEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.AssetChangeEntry", [], AssetChangeEntry, () => [["AssetId", int32_type], ["Name", string_type], ["Ticker", string_type], ["Market", string_type], ["Percentage", int32_type], ["Price", float64_type]]);
}

export class MarketChangeEntry extends Record {
    constructor(MarketId, Name, Ticker, Winners, Losers) {
        super();
        this.MarketId = (MarketId | 0);
        this.Name = Name;
        this.Ticker = Ticker;
        this.Winners = Winners;
        this.Losers = Losers;
    }
}

export function MarketChangeEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.MarketChangeEntry", [], MarketChangeEntry, () => [["MarketId", int32_type], ["Name", string_type], ["Ticker", string_type], ["Winners", array_type(AssetChangeEntry_$reflection())], ["Losers", array_type(AssetChangeEntry_$reflection())]]);
}

export class NoteEntry extends Record {
    constructor(Title, Desc) {
        super();
        this.Title = Title;
        this.Desc = Desc;
    }
}

export function NoteEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.NoteEntry", [], NoteEntry, () => [["Title", string_type], ["Desc", string_type]]);
}

export class ReportEntry extends Record {
    constructor(AssetId, Asset, Date$, Type) {
        super();
        this.AssetId = (AssetId | 0);
        this.Asset = Asset;
        this.Date = Date$;
        this.Type = (Type | 0);
    }
}

export function ReportEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.ReportEntry", [], ReportEntry, () => [["AssetId", int32_type], ["Asset", string_type], ["Date", string_type], ["Type", int32_type]]);
}

export class DividendEntry extends Record {
    constructor(Id, AssetId, Asset, Ticker, Market, ExDate, Amount, Currency) {
        super();
        this.Id = (Id | 0);
        this.AssetId = (AssetId | 0);
        this.Asset = Asset;
        this.Ticker = Ticker;
        this.Market = Market;
        this.ExDate = ExDate;
        this.Amount = Amount;
        this.Currency = Currency;
    }
}

export function DividendEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.DividendEntry", [], DividendEntry, () => [["Id", int32_type], ["AssetId", int32_type], ["Asset", string_type], ["Ticker", string_type], ["Market", string_type], ["ExDate", string_type], ["Amount", float64_type], ["Currency", string_type]]);
}

export class UpdateEntry extends Record {
    constructor(Title, Content) {
        super();
        this.Title = Title;
        this.Content = Content;
    }
}

export function UpdateEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.UpdateEntry", [], UpdateEntry, () => [["Title", string_type], ["Content", string_type]]);
}

export class MarketUpdateEntry extends Record {
    constructor(AssetId, Asset, Ticker, Market, Updates) {
        super();
        this.AssetId = (AssetId | 0);
        this.Asset = Asset;
        this.Ticker = Ticker;
        this.Market = Market;
        this.Updates = Updates;
    }
}

export function MarketUpdateEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.MarketUpdateEntry", [], MarketUpdateEntry, () => [["AssetId", int32_type], ["Asset", string_type], ["Ticker", string_type], ["Market", string_type], ["Updates", array_type(UpdateEntry_$reflection())]]);
}

export class IndexEntry extends Record {
    constructor(Quote, Date$) {
        super();
        this.Quote = Quote;
        this.Date = Date$;
    }
}

export function IndexEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.IndexEntry", [], IndexEntry, () => [["Quote", float64_type], ["Date", string_type]]);
}

export class IndexUpdateEntry extends Record {
    constructor(IndexId, Ticker, Name, CountryCode, AllTimeHigh, Latest, Previous) {
        super();
        this.IndexId = (IndexId | 0);
        this.Ticker = Ticker;
        this.Name = Name;
        this.CountryCode = CountryCode;
        this.AllTimeHigh = AllTimeHigh;
        this.Latest = Latest;
        this.Previous = Previous;
    }
}

export function IndexUpdateEntry_$reflection() {
    return record_type("PreOpenSummaryTypes.IndexUpdateEntry", [], IndexUpdateEntry, () => [["IndexId", int32_type], ["Ticker", string_type], ["Name", string_type], ["CountryCode", string_type], ["AllTimeHigh", bool_type], ["Latest", IndexEntry_$reflection()], ["Previous", IndexEntry_$reflection()]]);
}

export class PreOpenContent extends Record {
    constructor(LatestTradingDay, PreviousTradingDay, Commodities, Currencies, Markets, Notes, Reports, Dividends, MarketUpdates, Indexes, IndexDesc) {
        super();
        this.LatestTradingDay = LatestTradingDay;
        this.PreviousTradingDay = PreviousTradingDay;
        this.Commodities = Commodities;
        this.Currencies = Currencies;
        this.Markets = Markets;
        this.Notes = Notes;
        this.Reports = Reports;
        this.Dividends = Dividends;
        this.MarketUpdates = MarketUpdates;
        this.Indexes = Indexes;
        this.IndexDesc = IndexDesc;
    }
}

export function PreOpenContent_$reflection() {
    return record_type("PreOpenSummaryTypes.PreOpenContent", [], PreOpenContent, () => [["LatestTradingDay", string_type], ["PreviousTradingDay", string_type], ["Commodities", array_type(CommodityEntry_$reflection())], ["Currencies", array_type(CurrencyEntry_$reflection())], ["Markets", array_type(MarketChangeEntry_$reflection())], ["Notes", array_type(NoteEntry_$reflection())], ["Reports", array_type(ReportEntry_$reflection())], ["Dividends", array_type(DividendEntry_$reflection())], ["MarketUpdates", array_type(MarketUpdateEntry_$reflection())], ["Indexes", array_type(IndexUpdateEntry_$reflection())], ["IndexDesc", option_type(string_type)]]);
}

